<template>
  <div class="heightP100">
    <div class="container">
      <el-row class="queryHErow">
        <div class="floatL">
          <!-- <p>时间范围建议七天内</p> -->
          <el-date-picker v-model="value" type="datetimerange" :picker-options="pickerOptions" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" align="right" value-format="timestamp"
            :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>&nbsp;&nbsp;&nbsp;
          <el-select v-model="exchange" placeholder="请选择交易所" @change="getApi" clearable>
            <el-option v-for="item in exchangeList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <!-- <el-select
            v-model="exchange"
            placeholder="交易所"
            @change="getApi"
            clearable
          >
            <el-option
              v-for="(item, index) in exchangeList"
              :key="index"
              :label="elabel"
              :value="item"
            >
              <div v-if="item == '1'">KUCOIN</div>
              <div v-if="item == '2'">OKEX</div>
              <div v-if="item == '3'">BINANCE</div>
              <div v-if="item == '4'">BITMART</div>
              <div v-if="item == '5'">GATEIO</div>
              <div v-if="item == '6'">BITRUE</div>
              <div v-if="item == '7'">LBANK</div>
              <div v-if="item == '8'">HUOBI</div>
              <div v-if="item == '9'">COINONE</div>
              <div v-if="item == '10'">MXC</div>
              <div v-if="item == '11'">HOO</div>
              <div v-if="item == '12'">COINW</div>
              <div v-if="item == '13'">BITWELL</div>
              <div v-if="item == '14'">BYBIT</div>
            </el-option> </el-select
          > -->
          &nbsp;&nbsp;&nbsp;
          <el-select v-model="apiId" placeholder="API" @change="getSymbol" clearable>
            <el-option v-for="item in apiList" :key="item.id" :label="item.apiId" :value="item.apiId">
            </el-option> </el-select>&nbsp;&nbsp;&nbsp;
          <el-select v-model="symbol" placeholder="交易对">
            <el-option v-for="item in symbolList" :key="item.id" :label="item.symbol" :value="item.symbol">
            </el-option> </el-select>&nbsp;&nbsp;&nbsp;
          <el-select v-model="side" placeholder="方向" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="买" value="buy"></el-option>
            <el-option label="卖" value="sell"></el-option> </el-select>&nbsp;&nbsp;&nbsp;
          <el-select v-model="type" placeholder="类型" clearable>
            <el-option label="全部" value=""></el-option>
            <el-option label="限价交易" value="limit"></el-option>
            <el-option label="市价止损" value="market"></el-option>
          </el-select>
          <el-button type="primary" class="marginL10" @click="getTableData('1')" size="small">查询</el-button>
          <!-- <a-button type="primary"   @click="exportCsv()">导出</a-button> -->
          <el-button type="primary" class="marginL10" @click="exportCsv" size="small">导出CSV</el-button>
        </div>
      </el-row>
      <el-row class="marginT10">
        <el-table :data="orderTableData" style="width: 100%" height="700px">
          <el-table-column prop="id" label="委托编号" width="240">
            <template slot-scope="scope">
              {{ scope.row.id === "" ? "--" : scope.row.id }}
            </template>
          </el-table-column>
          <el-table-column prop="createAt" label="委托时间" width="180">
            <template slot-scope="scope">
              {{ scope.row.createAt === "" ? "--" : scope.row.createAt }}
            </template>
          </el-table-column>
          <el-table-column prop="symbol" label="交易对" width="120">
            <template slot-scope="scope">
              {{ scope.row.symbol === "" ? "--" : scope.row.symbol }}
            </template>
          </el-table-column>
          <el-table-column prop="side" label="方向" width="100">
            <template slot-scope="scope">
              {{ scope.row.side === "" ? "--" : "" }}
              <span v-if="scope.row.side == 'buy'" style="color: green">买</span>
              <span v-if="scope.row.side == 'sell'" style="color: red">卖</span>
            </template>
          </el-table-column>
          <el-table-column prop="opType" label="状态" width="120">
            <template slot-scope="scope">
              {{ scope.row.opType === "" ? "--" : scope.row.opType }}
            </template>
          </el-table-column>
          <el-table-column prop="size" label="委托数量">
            <template slot-scope="scope">
              {{ scope.row.size === "" ? "--" : scope.row.size }}
            </template>
          </el-table-column>
          <el-table-column prop="price" label="委托价格">
            <template slot-scope="scope">
              {{ scope.row.price === "" ? "--" : scope.row.price }}
            </template>
          </el-table-column>
          <el-table-column prop="funds" label="委托金额">
            <template slot-scope="scope">
              {{ scope.row.funds === "" ? "--" : scope.row.funds }}
            </template>
          </el-table-column>
          <el-table-column prop="dealSize" label="成交数量">
            <template slot-scope="scope">
              {{ scope.row.dealSize === "" ? "--" : scope.row.dealSize }}
            </template>
          </el-table-column>
          <el-table-column prop="dealAvgPrice" label="成交均价">
            <template slot-scope="scope">
              {{
            scope.row.dealAvgPrice === "NaN" ||
              scope.row.dealAvgPrice === ""
              ? "--"
              : scope.row.dealAvgPrice
          }}
            </template>
          </el-table-column>
          <el-table-column prop="hidden" label="隐藏" width="80">
            <template slot-scope="scope">
              {{ scope.row.hidden === "" ? "--" : "" }}
              <span v-if="scope.row.hidden == false" style="color: green">否</span>
              <span v-if="scope.row.hidden == true" style="color: red">是</span>
            </template>
          </el-table-column>
          <el-table-column prop="visibleSize" label="冰山单" width="80">
            <template slot-scope="scope">
              {{ scope.row.visibleSize === "" ? "--" : scope.row.visibleSize }}
            </template>
          </el-table-column>
          <el-table-column prop="type" label="类型" width="100">
            <template slot-scope="scope">
              {{ scope.row.type === "" ? "--" : "" }}
              <span v-if="scope.row.type == 'limit'">限价单</span>
              <span v-if="scope.row.type == 'market'">市价单</span>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-button size="small" type="primary" @click="getFirstPage()">首页</el-button>
      <el-button size="small" type="primary" @click="getLastPage()">上一页</el-button>
      <el-button size="small" type="primary" @click="getNextPage()">下一页</el-button>
    </div>
  </div>
</template>

<script>
import API from "./api";
import utils from "../lib/utils";
import dbPermission from "@/proto/dbPermission_pb";
import exQryOrders from "@/proto/exQryOrders_pb";
let mathjs = require("mathjs");
export default {
  data() {
    return {
      pageConfig: {
        currentPage: 1,
        totalNum: 0,
        totalPage: 0,
        pageSize: 15
      },
      exchange: "",
      apiId: "",
      symbol: "",
      side: "",
      type: "",
      select: [],
      exchangeList: [],
      apiList: [],
      symbolList: [],
      menuData: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
          // {
          //   text: "最近三个月",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          //     picker.$emit("pick", [start, end]);
          //   },
          // },
          // {
          //   text: "最近一年",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
          //     picker.$emit("pick", [start, end]);
          //   },
          // },
        ]
      },
      value: "",
      name: "hisEntrust",
      msg: "Welcome to Entrustttttttttttttttttttt",
      orderTableData: [],
      tableData: [], //表格全部数据
      elabel: ""
    };
  },
  computed: {
    key() {
      return this.$route.path + new Date().getTime();
    }
  },
  methods: {
    // 首页
    getFirstPage() {
      var page = 1;
      this.getTableData(page);
    },
    // 上一页
    getLastPage() {
      var that = this;
      let page;
      // 第一页
      if (that.pageConfig.currentPage === 1) {
        page = -2;
      } else {
        page = -(that.pageConfig.currentPage -= 1);
      }
      let exchange = that.exchange;
      if (exchange === 3 || exchange === 6 || exchange === 8 || exchange === 10 || exchange === 11 || exchange === 12 || exchange === 15 || exchange === 16) {
        if (that.pageConfig.currentPage === 1) {
          page = 1;
        } else {
          page = (that.pageConfig.currentPage -= 1);
        }
        let pageSize = 15;
        let start = (page - 1) * pageSize;
        let end = page * pageSize;
        if (that.pageConfig.totalNum > pageSize) {
          that.orderTableData = that.tableData.slice(start, end);
        } else {
          that.orderTableData = that.tableData;
        }
      } else {
        this.getTableData(page);
      }
    },
    // 下一页
    getNextPage() {
      var that = this;
      let page = (that.pageConfig.currentPage += 1);
      let pageSize = 15;
      let start = (page - 1) * pageSize;
      let end = page * pageSize;
      let exchange = that.exchange;
      if (exchange === 3 || exchange === 6 || exchange === 8 || exchange === 10 || exchange === 11 || exchange === 12 || exchange === 14 || exchange === 15 || exchange === 16) {
        if (that.pageConfig.totalNum > pageSize) {
          that.orderTableData = that.tableData.slice(start, end);
        } else {
          that.orderTableData = that.tableData;
        }
      } else {
        this.getTableData(page);
      }
    },
    // 初始化下拉框数据
    async getMenuData() {
      var data = {
        uid: localStorage.getItem("userName")
      };
      await API.getMenu(data)
        .then((res) => {
          if (res.data.errcode === 0) {
            var buffer = res.data.buffer;
            var message =
              dbPermission.DbPermissionList.deserializeBinary(buffer);
            var menuArray = [];
            var exchangeArray = [];
            var newArray = [];
            message.getPermissionsList().forEach((element) => {
              // console.log("element=", element);
              // 币种
              var token = element.getToken();
              // var uids = element.getUidsList()
              // var banUids = element.getBanuidsList()
              // var deleted = element.getDeleted()
              var item = {
                id: token,
                label: token
              };
              var apiArray = [];
              element.getApisList().forEach((api) => {
                var apiObj = {
                  id: token + api.getAlias(),
                  baseCurrency: element.getToken(),
                  apiId: api.getId(),
                  label: api.getAlias(),
                  exchange: api.getExchange()
                };
                var symbolArray = [];
                api.getSymbolsList().forEach((symbol) => {
                  var symbolObj = {
                    id: token + "-" + api.getAlias() + "-" + symbol,
                    token: token,
                    label: symbol,
                    symbol: symbol,
                    exchange: api.getExchange(),
                    apiId: api.getId(),
                    alias: api.getAlias()
                  };
                  symbolArray.push(symbolObj);
                });
                apiObj.children = symbolArray;
                exchangeArray.push(apiObj.exchange);
                apiArray.push(apiObj);
              });

              for (let i of exchangeArray) {
                if (!newArray.includes(i)) {
                  newArray.push(i);
                }
              }

              // this.select = apiArray;
              item.children = apiArray;
              menuArray.push(item);
            });
            // this.exchangeList = newArray;
            var exchangeList = [];
            newArray.forEach((ex) => {
              this.exchangeList.forEach((exchange) => {
                if (ex === exchange.id) {
                  exchangeList.push(exchange);
                }
              });
            });
            this.exchangeList = exchangeList;
            this.select = menuArray;
          } else {
            if (res.data.errcode === 1006) {
              this.$router.push("/login");
            }
          }
        })
        .catch((err) => {
          console.log("err=", err);
          this.$router.push("/login");
        });
    },
    // 获取exchange
    async getExchangesList() {
      var data = {
        'uid': localStorage.getItem("userName")
      };
      API.getExchangesLista(data).then(res => {
        // console.log("--------------"+JSON.stringify(res.data))
        if (res.data) {
          this.exchangeList = res.data;
        } else {
          console.log('getExchangesListMsg=', res.data.errcode + '-' + res.data.errmsg);
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 3005) {
            // 无效的登录凭证
            this.$router.push("/login");
          }
        }
      });
    },
    // 获取交易所下对应的api
    getApi() {
      this.apiList = [];
      this.symbolList = [];
      this.apiId = "";
      this.symbol = "";
      for (var i = 0; i < this.select.length; i++) {
        var obj = this.select[i].children;
        for (var j = 0; j < obj.length; j++) {
          if (this.exchange === obj[j].exchange) {
            this.apiList.push(obj[j]);
          }
        }
      }
    },
    // 获取api下对应的币对
    getSymbol() {
      this.symbolList = [];
      this.symbol = "";
      for (var i = 0; i < this.apiList.length; i++) {
        var obj = this.apiList[i];
        if (this.apiId === obj.apiId) {
          this.symbolList = obj.children;
        }
      }
    },
    getTableData(currentPage) {
      // 获取表格数据
      this.pageConfig.currentPage = Math.abs(parseInt(currentPage));
      let exchange = this.exchange;
      if (exchange === 3 || exchange === 6 || exchange === 8 || exchange === 10 || exchange === 11 || exchange === 12 || exchange === 14 || exchange === 15 || exchange === 16) {
        this.pageConfig.pageSize = 1000;
      } else {
        this.pageConfig.pageSize = 15;
      }
      var orderTableArray = [];
      var data = {
        uid: localStorage.getItem("userName"),
        apiId: this.apiId,
        status: "his",
        symbol: this.symbol,
        exchange: this.exchange,
        startAt: this.value[0],
        endAt: this.value[1],
        type: this.type,
        side: this.side,
        currentPage: currentPage.toString(),
        pageSize: this.pageConfig.pageSize + ""
      };
      if (!data.exchange) {
        this.$message({
          type: "error",
          message: "请选择交易所"
        });
        return;
      } else if (!data.apiId) {
        this.$message({
          type: "error",
          message: "请选择api"
        });
        return;
      } else if (!data.symbol) {
        this.$message({
          type: "error",
          message: "请选择币对"
        });
        return;
      }
      // 整页Loading
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      API.getOrders(data).then((res) => {
        if (res.data.errcode === 0) {
          var buffer = res.data.buffer;
          var message = exQryOrders.ExQryOrders.deserializeBinary(buffer);
          var orderData = message.getData();
          // this.pageConfig.totalPage = orderData.getTotalpage();
          // this.pageConfig.currentPage = orderData.getCurrentpage()
          orderData.getItemsList().forEach((element) => {
            // console.log('element=', element)
            var orderInfo = {
              id: element.getId(),
              // intId: element.getIntid(),
              createAt: utils.dateFormat(element.getCreatedat()),
              symbol: element.getSymbol(),
              side: element.getSide().toLowerCase(),
              opType: element.getOptype(),
              size: element.getSize(),
              price: element.getPrice(),
              funds: element.getFunds(),
              dealSize: element.getDealsize(),
              dealAvgPrice: "",
              hidden: element.getHidden(),
              visibleSize: element.getVisiblesize(),
              type: element.getType().toLowerCase(),
              // isActive: element.getIsactive(),
              // clientOid: element.getClientoid(),
              dealFunds: element.getDealfunds()
              // tradeType: element.getTradetype(),
              // cancelExist: element.getCancelexist(),
              // iceberg: element.getIceberg(),
              // postOnly: element.getPostonly(),
              // timeInForce: element.getTimeinforce(),
            };
            // 处理委托金额
            let fund = 0;
            fund = mathjs.multiply(
              mathjs.bignumber(element.getPrice()),
              mathjs.bignumber(element.getSize())
            );
            orderInfo.funds = utils.formatDecimal(fund, 8);
            // 处理成交均价
            if (element.getDealfunds() && element.getDealsize()) {
              let dealAvgPrice = 0;
              dealAvgPrice = mathjs.divide(
                mathjs.bignumber(element.getDealfunds()),
                mathjs.bignumber(element.getDealsize())
              );
              orderInfo.dealAvgPrice = utils.formatDecimal(dealAvgPrice, 8);
            }
            orderTableArray.push(orderInfo);
          });
          if (this.side) {
            orderTableArray = orderTableArray.filter((r) => {
              let row = r.side;
              return row.includes(this.side);
            });
          }
          if (this.type) {
            orderTableArray = orderTableArray.filter((r) => {
              let row = r.type;
              return row.includes(this.type);
            });
          }
          this.orderTableData = [];
          var orderLen = orderData.getItemsList().length;
          this.pageConfig.totalNum = orderLen;
          this.tableData = orderTableArray;
          let pageSize = 15;
          if (data.currentPage === "1") {
            if (orderLen > pageSize) {
              let start = (data.currentPage - 1) * pageSize;
              let end = data.currentPage * pageSize;
              this.orderTableData = orderTableArray.slice(start, end);
            } else {
              this.orderTableData = orderTableArray;
            }
          } else {
            this.orderTableData = orderTableArray;
          }
          loading.close();
        } else {
          loading.close();
          this.$message.error(res.data.errcode + ":" + res.data.errmsg);
          if (res.data.errcode === 4004) {
            this.pageConfig.currentPage = this.pageConfig.currentPage - 1;
          }
          // console.log('getOrders errmsg', res.data.errcode + '-' + res.data.errmsg)
        }
      });
    },
    // 导出指令csv文件
    exportCsv() {
      // '\n'表示一行的结束
      // ','表示数据依次放在新的单元格
      const header = [
        "委托编号",
        "委托时间",
        "交易对",
        "方向",
        "状态",
        "委托数量",
        "委托价格",
        "委托金额",
        "成交数量",
        "成交均价",
        "隐藏",
        "冰山单",
        "类型"
      ];
      const table =
        header.join(",") +
        "\n" +
        this.orderTableData
          .map((item) => {
            let result = "";
            for (const key in item) {
              result += `${item[key] + "\t"},`; // 增加\t为了不让表格显示科学计数法或者其他格式
            }
            return result;
          })
          .join("\n");
      // encodeURIComponent解决中文乱码
      let uri =
        "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(table);
      // 通过创建a标签实现
      var link = document.createElement("a");
      link.href = uri;
      // 对下载的文件命名
      link.download = "Entrust.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async init() {
      await this.getExchangesList();
      await this.getMenuData();
    }
  },
  created() {
    this.init();
  }
};
</script>

<style scoped>
@import "../assets/css/hisEntrust.scss";
</style>
